/* Amboina theme, interacties. Bewust licht gehouden. */
(function () {
  "use strict";

  /* Sticky header, schaduw/blur na scrollen */
  function stickyHeader() {
    var header = document.querySelector(".header");
    if (!header) return;
    var onScroll = function () { header.classList.toggle("is-stuck", window.scrollY > 12); };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* Off-canvas drawer (mobile menu, catalog drawer): keeps aria-expanded on its toggles in sync,
     moves focus into the drawer on open and back to the toggle that opened it on close. */
  function drawer(panel) {
    var opener = null;
    function isOpen() { return panel.classList.contains("is-open"); }
    function set(open, trigger) {
      panel.classList.toggle("is-open", open);
      document.querySelectorAll('[aria-controls="' + panel.id + '"]').forEach(function (b) {
        b.setAttribute("aria-expanded", open ? "true" : "false");
      });
      if (open) {
        opener = trigger || null;
        var first = panel.querySelector("button, a[href], input, summary");
        if (first) first.focus({ preventScroll: true });
      } else if (opener) {
        opener.focus({ preventScroll: true });
        opener = null;
      }
    }
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && isOpen()) set(false);
    });
    return { set: set, isOpen: isOpen };
  }

  /* Mobile menu. From tablet width it is a side drawer, so a tap on the dimmed page beside it closes it too. */
  function mobileMenu() {
    var panel = document.getElementById("mobile-menu");
    if (!panel) return;
    var d = drawer(panel);
    document.addEventListener("click", function (e) {
      var t = e.target;
      var open = t.closest('[data-action="menu-open"]');
      if (open) { d.set(true, open); return; }
      if (d.isOpen() && (t.closest('[data-action="menu-close"]') || t.closest(".mobile-menu a") || !panel.contains(t))) d.set(false);
    });
  }

  /* Scroll-reveal via IntersectionObserver */
  function scrollReveal() {
    var els = document.querySelectorAll(".reveal");
    if (!("IntersectionObserver" in window) || !els.length) {
      els.forEach(function (el) { el.classList.add("is-visible"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Catalog sidebar; a drawer on tablet and mobile. Keeps the active category in view (a third from the
     top) without moving the page: on desktop inside the height-limited list under the main category,
     in the drawer when that scrolls as a whole. Runs on load and when the drawer opens. */
  function catalogNav() {
    var aside = document.getElementById("catalog-nav");
    if (!aside) return;
    var d = drawer(aside);
    function showActive() {
      var active = aside.querySelector(".cat-nav__link.is-active");
      if (!active) return;
      var box = active.closest(".cat-nav__list > li > .cat-nav__sub");
      if (!box || box.scrollHeight <= box.clientHeight) box = aside;
      if (box.scrollHeight <= box.clientHeight) return;
      var a = active.getBoundingClientRect(), b = box.getBoundingClientRect();
      if (a.top < b.top || a.bottom > b.bottom - 32) {
        box.scrollTop += a.top - b.top - box.clientHeight / 3;
      }
    }
    showActive();
    document.addEventListener("click", function (e) {
      var toggle = e.target.closest('[data-action="catnav-toggle"]');
      if (toggle) {
        d.set(!d.isOpen(), toggle);
        if (d.isOpen()) showActive();
        return;
      }
      if (d.isOpen() && !aside.contains(e.target)) d.set(false);
    });
  }

  /* Header-zoekbalk open/dicht (icoon-toggle, alle schermen) */
  function headerSearch() {
    var form = document.querySelector(".nav__search");
    if (!form) return;
    document.addEventListener("click", function (e) {
      if (e.target.closest('[data-action="search-toggle"]')) {
        form.classList.toggle("is-open");
        if (form.classList.contains("is-open")) {
          var input = form.querySelector('input[name="q"]');
          if (input) input.focus();
        }
        return;
      }
      if (form.classList.contains("is-open") && !e.target.closest(".nav__search")) {
        form.classList.remove("is-open");
      }
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") form.classList.remove("is-open");
    });
  }

  /* Hero carousel with progress bar (pattern from the webportal CmsBannerSlider).
     One requestAnimationFrame loop counts the time, draws the bar and switches the slide the moment
     the bar is full, so bar and slide never drift apart. Pauses while hovered or focused and while
     the tab is hidden; a manual switch (dot, arrow, swipe) resets the bar. With
     prefers-reduced-motion it does not advance and the bar is hidden. */
  function heroCarousel() {
    var root = document.querySelector(".hero-carousel");
    if (!root) return;
    var slides = Array.prototype.slice.call(root.querySelectorAll(".hero-carousel__slide"));
    var dots = Array.prototype.slice.call(root.querySelectorAll(".hero-carousel__dot"));
    var bar = root.querySelector(".hero-carousel__progress");
    var fill = bar ? bar.querySelector("span") : null;
    if (slides.length < 2) return;

    var DELAY = 8000;
    var index = 0;
    var elapsed = 0;
    var last = 0;
    var paused = false;
    // Pause button (WCAG 2.2.2): a visitor can stop the auto-advance for good, also on touch
    var stopped = false;
    var pauseBtn = root.querySelector("[data-carousel-pause]");
    var reduce = window.matchMedia ? window.matchMedia("(prefers-reduced-motion: reduce)") : { matches: false };

    function show(i) {
      index = (i + slides.length) % slides.length;
      elapsed = 0;
      slides.forEach(function (s, n) { s.classList.toggle("is-active", n === index); });
      dots.forEach(function (d, n) {
        var on = n === index;
        d.classList.toggle("is-active", on);
        d.setAttribute("aria-selected", on ? "true" : "false");
      });
    }

    function tick(now) {
      window.requestAnimationFrame(tick);
      var dt = last ? now - last : 0;
      last = now;
      if (bar) bar.classList.toggle("is-off", reduce.matches);
      if (pauseBtn) pauseBtn.hidden = reduce.matches;
      if (!(paused || stopped || reduce.matches || document.hidden)) {
        elapsed += dt;
        if (elapsed >= DELAY) show(index + 1);
      }
      // Drawn every frame, also while paused, so a manual switch resets the bar at once.
      if (fill) fill.style.transform = "scaleX(" + Math.min(elapsed / DELAY, 1) + ")";
    }

    root.addEventListener("click", function (e) {
      if (pauseBtn && e.target.closest("[data-carousel-pause]")) {
        stopped = !stopped;
        pauseBtn.classList.toggle("is-paused", stopped);
        pauseBtn.setAttribute("aria-label", stopped ? pauseBtn.dataset.labelPlay : pauseBtn.dataset.labelPause);
        return;
      }
      if (e.target.closest("[data-carousel-next]")) { show(index + 1); return; }
      if (e.target.closest("[data-carousel-prev]")) { show(index - 1); return; }
      var dot = e.target.closest(".hero-carousel__dot");
      if (dot) show(dots.indexOf(dot));
    });

    root.addEventListener("mouseenter", function () { paused = true; });
    root.addEventListener("mouseleave", function () { paused = false; });
    root.addEventListener("focusin", function () { paused = true; });
    root.addEventListener("focusout", function () { paused = false; });

    var x0 = null;
    root.addEventListener("pointerdown", function (e) { x0 = e.clientX; });
    root.addEventListener("pointerup", function (e) {
      if (x0 === null) return;
      var dx = e.clientX - x0;
      x0 = null;
      if (Math.abs(dx) > 40) show(index + (dx < 0 ? 1 : -1));
    });

    window.requestAnimationFrame(tick);
  }

  function init() {
    stickyHeader();
    mobileMenu();
    scrollReveal();
    catalogNav();
    headerSearch();
    heroCarousel();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
